import { RefinementList } from './types'

/**
 * Returns a new refinement list with updates applied to a copy of the original.
 * @param {object} options - Options object.
 * @param {RefinementList} [options.refinementList={}] - The original refinement list.
 * @param {Partial<RefinementList>} [options.updates={}] - The updates to apply to the refinement list copy.
 * @returns {RefinementList} The updated refinement list.
 */
export function updateRefinementList({
  refinementList = {},
  updates = {}
}: {
  refinementList?: RefinementList
  updates?: Partial<RefinementList>
}): RefinementList {
  return {
    ...refinementList,
    ...updates
  }
}
